import { useSelector } from "react-redux";
import CartItemList from "./CartItemList";

function CartItem(){    
    const cart = useSelector((state) => state.cart);    
    return(
        <div className="space-y-6">
           {/* Cart Item  */}  
           {cart.map((cart)=>(
            <CartItemList cart={cart} key={cart.id} />
        ))}
        {/* Cart Items Ends*/}

        </div>
    )
}

export default CartItem;